import axios from 'axios'
import { AgendamentoModel, TurmaModel } from '../../../components/models/Models'

export async function notificationPilotar(
  agendamento: AgendamentoModel,
  notificationType: 'AGENDAMENTO',
  turma?: TurmaModel
) {
  const data = getDataPilotarWebHookPilotar(agendamento, notificationType, turma)
  await sendNotificationPilotar(data)
}

type DataPilotarNotificationDto = ReturnType<typeof getDataPilotarWebHookPilotar>
function getDataPilotarWebHookPilotar(
  agendamento: AgendamentoModel,
  notificationType: 'AGENDAMENTO',
  turma?: TurmaModel
) {
  const baseURL = getBaseUrl()
  return {
    baseURL,
    notificationType,
    tipoAgendamento: agendamento.tipoAgendamento,
    cpf: agendamento.cpf,
    renach: agendamento.renach,
    identificadorCobranca: agendamento.identificadorCobranca,
    cfcDestino: {
      id: agendamento.cfcDestino?.id,
      cnpj: agendamento.cfcDestino?.cnpj,
      fantasia: agendamento.cfcDestino?.fantasia,
      municipio: agendamento.cfcDestino?.municipio,
    },
    ...(!!turma && {
      turma: {
        id: turma.id,
        dataInicio: turma.dataInicio,
        dataTermino: '',
        modalidade: turma.modalidade,
      },
    }),
  }
}

function getBaseUrl() {
  const search = window.location.search
  const urlSearch = new URLSearchParams(search)
  const baseUrl = urlSearch.get('url_callback')
  return baseUrl
}

async function sendNotificationPilotar(data: DataPilotarNotificationDto) {
  try {
    await axios.post('/agendamentos/notificacao-pilotar', data).then((res) => res.data)
  } catch (error) {}
}
